// extracted by mini-css-extract-plugin
module.exports = {"header":"BaggageSegment-module__header___1gnN3","listItem":"BaggageSegment-module__listItem___iFK7-"};